import request from '@/utils/request'

export function list(params) {
  return request({
    url: '/api/zh-cn/developer-platform/team/list',
    method: 'get',
    params
  })
}

export function quit(data) {
  return request({
    url: '/api/zh-cn/developer-platform/team/quit',
    method: 'post',
    data
  })
}
